import { useRouter } from 'next/router';
import { Flex, Text } from '@chakra-ui/react';
import { SIDENAV_WIDTH } from './sidenav';
import FeedbackModule from './feedback-module';

export function DocsFooter(): JSX.Element {
  const router = useRouter();

  return (
    <Flex
      as="footer"
      direction={{ base: 'column', md: 'row' }}
      align={{ base: 'flex-start', md: 'center' }}
      justify="space-between"
      bg="var(--bodyBg)"
      gap={8}
      pos="relative"
      borderTop="1px solid"
      borderColor="var(--borderColor)"
      px={6}
      pt={{ base: 8, md: 4 }}
      pb={4}
      w={{ base: 'full', lg: `calc(100vw - ${SIDENAV_WIDTH})` }}
      left={{ base: 0, lg: SIDENAV_WIDTH }}
    >
      <Flex w="full">
        <FeedbackModule key={router.asPath} />
      </Flex>

      <Text
        textStyle="sm-normal"
        color="var(--secondaryTextColor)"
        mr={6}
        whiteSpace="nowrap"
        style={{ alignSelf: 'flex-start', marginTop: '10px' }}
      >
        Clerk &copy; {new Date().getUTCFullYear()}
      </Text>
    </Flex>
  );
}
